module.exports = __webpack_public_path__ + "media/images/writer/monitor/txt-about-7b7353253c2ca241e56dd0a66f2d1c62.png";